
import { computed, defineComponent, onMounted } from "vue";
import { listTetapanBorang } from "@/apollo/pentadbiran/tetapanBorang";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import CustomCardWidget1 from "@/components/custom/cards/Widget1.vue";
import { useQuery } from "@vue/apollo-composable";

export default defineComponent({
  name: "form-setting-listing",
  components: {
    CustomCardWidget1,
  },
  setup() {
    const { result } = useQuery(listTetapanBorang, null, {
      fetchPolicy: "no-cache",
    });

    const forms = computed(() => result.value?.tetapanBorangList ?? []);

    const examinations = computed(() => {
      if (forms.value.length > 0) {
        return forms.value.filter((form) => form.jenis_borang == "PEPERIKSAAN");
      } else {
        return [];
      }
    });

    const services = computed(() => {
      if (forms.value.length > 0) {
        return forms.value.filter(
          (form) => form.jenis_borang == "PERKHIDMATAN"
        );
      } else {
        return [];
      }
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs("Tetapan Borang", ["Pentadbiran Sistem"]);
    });

    const buildDescription = (
      acknowledgements: Array<string> | null,
      additionalFields: Array<string> | null
    ) => {
      return `<span class='badge badge-white border-dashed me-2'>${
        acknowledgements?.length ?? 0
      } Perakuan</span><span class='badge badge-white border-dashed me-2'>${
        additionalFields?.length ?? 0
      } Medan Tambahan</span>`;
    };

    return {
      buildDescription,
      examinations,
      forms,
      services,
    };
  },
});
